import { render } from "./MovieDetailPage.vue?vue&type=template&id=55a813c8"
import script from "./MovieDetailPage.vue?vue&type=script&lang=js"
export * from "./MovieDetailPage.vue?vue&type=script&lang=js"

import "./MovieDetailPage.vue?vue&type=style&index=0&id=55a813c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__